module.exports = __webpack_public_path__ + "img/icons BFr_37.d904fbf0.svg";